import React from "react";
import styles from "./Tabs.module.css";

const Tabs = ({ tabs, activeTab, onChange }) => {
  return (
    <div className={styles.tabsContainer}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.tabButton} ${activeTab === tab.key ? styles.active : ""}`}
          onClick={() => onChange(tab.key)}
          type="button"
        >
          {tab.icon && <span className={styles.icon}>{tab.icon}</span>}
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default Tabs;